/**
 * Property Item component runtime terms
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const propertyItem = {
	copy: {
		label: "component:propertyItem.copy#label",
		message: "component:propertyItem.copy#message"
	},
	showValue: {
		label: "component:propertyItem.showValue#label"
	},
	hideValue: {
		label: "component:propertyItem.hideValue#label"
	}
};
